export type AssetSource = {
  source: string
  avif?: string
  webp?: string
}

export type PictureSource = {
  srcSet: string
  type: 'image/avif' | 'image/webp'
}

export const getAssetSources = ({
  avif,
  webp
}: AssetSource): PictureSource[] => {
  const sources: PictureSource[] = []

  if (avif) {
    sources.push({ srcSet: avif, type: 'image/avif' })
  }

  if (webp) {
    sources.push({ srcSet: webp, type: 'image/webp' })
  }

  return sources
}
